import { Upload } from "antd";
import React, { useState, useEffect } from "react";
import { useUploadImageMutation } from "../store/appSlice";

function ImageUploader({getImageFile}){
    const [filesLists, setfilesLists] = useState([]);
    const [uploadImage] = useUploadImageMutation();


    useEffect(() => {
        if (filesLists.length > 0 && !filesLists[0].url) {
          onFileChange();
        }
      }, [filesLists]);


    const onFileChange = async () => {
        let formData = new FormData();
        formData.append("file", filesLists[0].originFileObj);
        // console.log({ filesLists });
        // console.log({ data: filesLists[0].originFileObj });
        // console.log(formData);
    
        uploadImage(formData) 
          .unwrap()
          .then((data) => {
            // console.log({ data });
            getImageFile(data.url);
          })
          .catch((err) => {});
      };

    
      const onChangeFile = (file) => {
        setfilesLists(file.fileList);
      };



    return(
    <Upload
    multiple={false}
    listType="picture-card"
    fileList={filesLists}
    accept="image/*"
    onChange={onChangeFile}
    // onPreview={onPreview}
    onPreview={()=>{}}
    beforeUpload={() => false}
  >
    {filesLists.length <= 0 && (
      <div className="upload-inner-text">
        <h3>512 x 512</h3>
        <p>Click here to upload</p>
      </div>
    )}
  </Upload>
    )
}

export default ImageUploader